export const moduleName = 'launchManagementModule';
